import { createClient } from '@supabase/supabase-js';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYzODM3OTQzMywiZXhwIjoxOTUzOTU1NDMzfQ.ooOGQ0dPOSmc3a8AUeITZcg94ur3KYk0rSoWVypObhE';
const SUPABASE_URL = "https://rmstbyaloduqcenvdgtr.supabase.co";
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
